import { Component, Renderer2 } from '@angular/core';
import { CarouselBannerComponent } from '../../components/carousel-banner/carousel-banner.component';
import { CarouselCardComponent } from '../../components/carousel-card/carousel-card.component';
import { ContentAreaComponent } from "../../components/content-area/content-area.component";
import { TabContent1Component } from "../../components/tab-content1/tab-content1.component";
import { ContentCardComponent } from '../../components/content-card/content-card.component';
import { SimpleFormComponent } from '../../components/simple-form/simple-form.component';
import { TabContentComponent } from "../../components/tab-content/tab-content.component";
import { ContentArea2Component } from "../../components/content-area2/content-area2.component";
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';


@Component({
    selector: 'app-home',
    imports: [CarouselBannerComponent, ContentAreaComponent, CarouselCardComponent,
        TabContent1Component, ContentCardComponent, SimpleFormComponent,
        TabContentComponent, ContentArea2Component,
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    standalone: true,
})
export class HomeComponent {
    private metaDataSet: boolean = false;
    solutionData: any = {
        heading: "Exclusive Solutions for <u>Your Needs</u>",
        description: "<p>We help create strategies designed to achieve your individual, family, and business goals.</p>",
    }

    constructor(private meta: Meta,

        private title: Title, private route: ActivatedRoute,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,

    ) {
    }
    ngOnInit(): void {
        if (!this.metaDataSet) {
            const meta = {
                title: "Shriram Wealth - Personalized Solutions to Grow your Wealth",
                description: "We deliver simple, strategic, unique, transparent and personalized wealth management solutions  to grow your wealth.",
                twitter_title: "Shriram Wealth - Personalized Solutions to Grow your Wealth",
                twitter_description: "We deliver simple, strategic, unique, transparent and personalized wealth management solutions  to grow your wealth.",
                og_title: "Shriram Wealth - Personalized Solutions to Grow your Wealth",
                og_description: "We deliver simple, strategic, unique, transparent and personalized wealth management solutions  to grow your wealth.",
                keywords: "shriram wealth, wealth management solutions, wealth management service, wealth management system, wealth management company"
            };

            // Set Title and Meta tags
            this.title.setTitle(meta.title);
            this.meta.updateTag({ name: 'description', content: meta.description });
            this.meta.updateTag({ name: 'twitter:title', content: meta.twitter_title });
            this.meta.updateTag({ name: 'twitter:description', content: meta.twitter_description });
            this.meta.updateTag({ property: 'og:title', content: meta.og_title });
            this.meta.updateTag({ property: 'og:description', content: meta.og_description });
            this.meta.updateTag({ name: 'keywords', content: meta.keywords });


            let head = this.document.getElementsByTagName('head')[0];
            var element: HTMLLinkElement | null =
                this.document.querySelector(`link[rel='canonical']`) || null;
            if (element == null) {
                element = this.document.createElement('link') as HTMLLinkElement;
                head.appendChild(element);
            }
            element.setAttribute('rel', 'canonical');
            element.setAttribute('href', environment.appUrl);
            this.metaDataSet = true;
        }

        const jsonLdData = {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Shriram Wealth",
            "url": environment.appUrl,
            "logo": environment.appUrl + "assets/images/wealth-logo.png",
            "sameAs": [
                "https://www.facebook.com/profile.php?id=61570845327379",
                "https://x.com/ShriramWealth01",
                "https://www.instagram.com/shriram.wealth/",
                "https://www.linkedin.com/company/shriram-wealth/about/"
            ]
        };

        // Dynamically add JSON-LD Schema
        const scriptElement = this.renderer.createElement('script');
        this.renderer.setAttribute(scriptElement, 'type', 'application/ld+json');
        this.renderer.setProperty(scriptElement, 'innerHTML', JSON.stringify(jsonLdData));

        // Remove any existing schema to prevent duplication
        const existingScript = this.document.querySelector('script[type="application/ld+json"]');
        if (existingScript) {
            this.renderer.removeChild(this.document.head, existingScript);
        }

        // Append the schema script
        this.renderer.appendChild(this.document.head, scriptElement);


    }
}



